const META_PIXEL_DELAY_MS = 300;

export type MetaPixelEventName = 'Contact' | 'Lead' | 'PageView' | 'Schedule';

export function trackMetaPixel(
  eventName: MetaPixelEventName,
  parameters?: Record<string, unknown>,
) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return false;
  }

  if (parameters && Object.keys(parameters).length > 0) {
    window.fbq('track', eventName, parameters);
  } else {
    window.fbq('track', eventName);
  }

  return true;
}

export async function trackMetaPixelBeforeNavigation(
  eventName: MetaPixelEventName,
  parameters?: Record<string, unknown>,
) {
  const didTrack = trackMetaPixel(eventName, parameters);

  if (!didTrack) {
    return;
  }

  await new Promise((resolve) => {
    window.setTimeout(resolve, META_PIXEL_DELAY_MS);
  });
}
